import { Content } from "./Edit";

export default function Save(props) {
  return <Content {...props} isSave={true} />;
}
